$(document).ready(function(){
    $('.ajax-form-cost').submit(function(e) {
        e.preventDefault();
        var form = $(this);
        $('input[type="submit"]', form).each(function() {
            $(this).attr('disabled', 'disabled');
            $(this).addClass('disabled');
        });


        $.ajax({
            url: form.attr('action'),
            method: "POST",
            data: form.serialize(),
            dataType: 'json',
            success: function(data) {
                form.parents('.container-flex').find('.alert').remove();
                form.html('<span class="success">' + data.html + '</span>');
            },
            error: function(xhr) {
                data = xhr.responseJSON;
                if(xhr.status==422) {
                    form.parents('.container-flex').find('.alert').remove();
                    form.parents('.container-flex').append('<div class="alert alert-danger"><ul></ul></div>')
                    for (key in data.errors) {
                        form.parents('.container-flex').find('.alert ul').append('<li>' + data.errors[key].join(', ') + '</li>');
                    }
                }
                $('input[type="submit"]', form).each(function() {
                    $(this).removeAttr('disabled');
                    $(this).removeClass('disabled');
                });             
            }
        });

    });

});